<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!accepting"
  [closeOnEscape]="!accepting"
  [style]="{ width: '540px', maxWidth: 'calc(100vw - 32px)' }"
  styleClass="employee-license-dialog"
  [header]="title | translate"
  (onHide)="onHide()"
>
  <div class="employee-license-intro">
    <span
      class="employee-license-icon"
      [class.employee-license-icon--success]="state === 'success'"
      [class.employee-license-icon--neutral]="
        state === 'expired' || state === 'restricted'
      "
      aria-hidden="true"
    >
      <i
        class="pi"
        [ngClass]="
          state === 'success'
            ? 'pi-check'
            : state === 'expired'
              ? 'pi-clock'
              : 'pi-arrow-up'
        "
      ></i>
    </span>
    <p *ngIf="loading" role="status" translate>EMPLOYEE_LICENSE.LOADING</p>
    <p *ngIf="!loading && state === 'offer' && quote">
      {{
        "EMPLOYEE_LICENSE.UPGRADE_INTRO"
          | translate
            : { limit: quote.NewEmployeeLimit - quote.AdditionalEmployees }
      }}
    </p>
    <p *ngIf="state === 'success' && quote" role="status">
      {{
        "EMPLOYEE_LICENSE.SUCCESS_DETAIL"
          | translate: { limit: quote.NewEmployeeLimit }
      }}
    </p>
    <p *ngIf="state === 'expired'" translate>EMPLOYEE_LICENSE.EXPIRED_DETAIL</p>
    <p *ngIf="state === 'restricted'" translate>
      EMPLOYEE_LICENSE.RESTRICTED_DETAIL
    </p>
    <p *ngIf="state === 'error'" role="alert" translate>
      EMPLOYEE_LICENSE.RETRY_DETAIL
    </p>
  </div>

  <div *ngIf="state === 'offer'" class="employee-license-quantity">
    <span id="employee-license-quantity-label" translate
      >EMPLOYEE_LICENSE.ADDITIONAL_EMPLOYEES</span
    >
    <div
      class="employee-license-quantity__controls"
      role="group"
      aria-labelledby="employee-license-quantity-label"
      [attr.aria-busy]="loading"
    >
      <button
        type="button"
        class="btn btn-outline-secondary"
        [attr.aria-label]="'EMPLOYEE_LICENSE.DECREASE_EMPLOYEES' | translate"
        [disabled]="loading || accepting || additionalEmployees <= 1"
        (click)="changeQuantity(-1)"
      >
        <i class="pi pi-minus" aria-hidden="true"></i>
      </button>
      <output aria-live="polite">{{ additionalEmployees }}</output>
      <button
        type="button"
        class="btn btn-outline-secondary"
        [attr.aria-label]="'EMPLOYEE_LICENSE.INCREASE_EMPLOYEES' | translate"
        [disabled]="loading || accepting"
        (click)="changeQuantity(1)"
      >
        <i class="pi pi-plus" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <ng-container *ngIf="!loading && state === 'offer' && quote">
    <dl class="employee-license-summary">
      <div>
        <dt translate>EMPLOYEE_LICENSE.CURRENT_LIMIT</dt>
        <dd>{{ quote.NewEmployeeLimit - quote.AdditionalEmployees }}</dd>
      </div>
      <div>
        <dt translate>EMPLOYEE_LICENSE.NEW_LIMIT</dt>
        <dd class="employee-license-highlight">{{ quote.NewEmployeeLimit }}</dd>
      </div>
      <div>
        <dt translate>EMPLOYEE_LICENSE.LICENSE_VALID_UNTIL</dt>
        <dd>
          {{
            quote.ExpiryDate
              ? (quote.ExpiryDate | date: "dd.MM.yyyy")
              : ("EMPLOYEE_LICENSE.NO_EXPIRY" | translate)
          }}
        </dd>
      </div>
    </dl>
    <div class="employee-license-price">
      <div>
        <strong translate>EMPLOYEE_LICENSE.MONTHLY_INCREASE</strong>
        <p>
          {{
            "EMPLOYEE_LICENSE.MONTHLY_CALCULATION"
              | translate
                : {
                    count: quote.AdditionalEmployees,
                    price: (quote.PricePerEmployeePerMonth | number: "1.0-2"),
                    currency: quote.Currency
                  }
          }}
        </p>
      </div>
      <div class="employee-license-price__amount">
        {{ quote.Amount | number: "1.0-2" }} {{ quote.Currency
        }}<span translate>EMPLOYEE_LICENSE.PER_MONTH</span>
      </div>
    </div>
    <p class="employee-license-note" translate>EMPLOYEE_LICENSE.UPGRADE_NOTE</p>
  </ng-container>

  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      [disabled]="accepting"
      (click)="close()"
    >
      {{
        (state === "offer" ? "EMPLOYEE_LICENSE.NOT_NOW" : "CLOSE") | translate
      }}
    </button>
    <button
      *ngIf="state === 'offer'"
      type="button"
      class="btn btn-primary"
      [disabled]="loading || accepting || !quote"
      (click)="accept()"
    >
      <i *ngIf="accepting" class="pi pi-spinner pi-spin" aria-hidden="true"></i>
      {{ "EMPLOYEE_LICENSE.ACCEPT_UPGRADE" | translate }}
    </button>
    <button
      *ngIf="state === 'success'"
      type="button"
      class="btn btn-primary"
      (click)="continue()"
      translate
    >
      EMPLOYEE_LICENSE.CONTINUE
    </button>
    <button
      *ngIf="state === 'error'"
      type="button"
      class="btn btn-primary"
      (click)="loadQuote()"
      translate
    >
      EMPLOYEE_LICENSE.RETRY
    </button>
    <a
      *ngIf="state === 'expired'"
      class="btn btn-primary"
      href="https://kuba.no/fa-tilbud/"
      target="_blank"
      rel="noopener noreferrer"
      translate
      >EMPLOYEE_LICENSE.CONTACT_SALES</a
    >
  </ng-template>
</p-dialog>
